/**
 * Capitalize the first letter of every space-separated token in a person's
 * name (first/last name first letter as capital). Empty / whitespace-only
 * input returns "". The rest of each token is preserved as the user typed
 * it so we don't smash hyphenated names like "Mary-Anne" or proper nouns
 * like "McDonald".
 */
export function capitalizeName(name: string | null | undefined): string {
  if (!name) return "";
  const trimmed = name.trim();
  if (!trimmed) return "";
  return trimmed
    .split(/\s+/)
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : ""))
    .join(" ");
}
